import * as Types from '../types-api.generated';

import { CollectionFragment } from '../api-fragments.generated';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUpdateCollectionHiddenAtVariables = Types.Exact<{
  hidden: Types.Scalars['Boolean'];
  id: Types.Scalars['ID'];
}>;


export type ApiUpdateCollectionHiddenAt = { updateCollectionHiddenAt: { id: string, contractAddress: string, symbol: string, name: string, slug: string | null, description: string | null, collectionImageUrl: string | null, coverImageUrl: string | null, createdAt: string, updatedAt: string } | null };



export const ApiUpdateCollectionHiddenAtDocument = /*#__PURE__*/ `
    mutation UpdateCollectionHiddenAt($hidden: Boolean!, $id: ID!) {
  updateCollectionHiddenAt(hidden: $hidden, id: $id) {
    ...CollectionFragment
  }
}
    ${CollectionFragment}`;

export const useUpdateCollectionHiddenAt = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiUpdateCollectionHiddenAt, TError, ApiUpdateCollectionHiddenAtVariables, TContext>) => {
    
    return useMutation<ApiUpdateCollectionHiddenAt, TError, ApiUpdateCollectionHiddenAtVariables, TContext>(
      {
    mutationKey: ['UpdateCollectionHiddenAt'],
    mutationFn: (variables?: ApiUpdateCollectionHiddenAtVariables) => apiFetcher<ApiUpdateCollectionHiddenAt, ApiUpdateCollectionHiddenAtVariables>(ApiUpdateCollectionHiddenAtDocument, variables)(),
    ...options
  }
    )};


useUpdateCollectionHiddenAt.fetcher = (variables: ApiUpdateCollectionHiddenAtVariables, options?: RequestInit['headers']) => apiFetcher<ApiUpdateCollectionHiddenAt, ApiUpdateCollectionHiddenAtVariables>(ApiUpdateCollectionHiddenAtDocument, variables, options);
